<template>
  <div class="modal fade" id="myOCRPinModal" role="dialog">
    <div class="modal-dialog modal-dialog-centered model-lg">
      <div class="modal-content">
        <div class="modal-head d-flex">
          <img src="@/assets/images/done.png" class="tick border-0 position-relative mt-5 " />
        </div>
        <div class="modal-body text-center pb-0  position-relative ">
          <p class="text-center portrait-body">OCR PIN link has been successfully sent</p>
          <p class="font-weight-bold text-center">OCR PIN : 2020-00001234</p>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 text-center d-flex justify-content-center mt-1 mb-5 ">
          <button type="button" id="done" class="btn bgc-btn-primary w-25" data-dismiss="modal">Done</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
export default {
  name: "OCRPinModal",
  components: {
    FloatLabel
  },
};
</script>

<style scoped>
.modal-head{
    -ms-flex-negative:0;
    flex-shrink:0;
    margin: 28px 5px 12px 5px;
    justify-content:space-between;
}
.modal-body {
  overflow-y: hidden;
}
.btn:hover {
  color: #ffffff;
}
.tick {
  color: white;
  width: 50px;
  height: 50px;
  left: 46%;
}

@media (min-width: 375px) {
  .portrait-body {
    width: 103%;
  } 
}
@media (min-width: 360px) {
  .portrait-body {
    width: 108%;
  } 
}
</style>